import { Injectable } from '@angular/core';
import { CompanyEmployeeWithSubsidyAmount } from '@app/@graphql';
import { Observable, of } from 'rxjs';
import { CompanyData, CompaniesData, DeliveryLocation } from '../data/company-data';
import { CompanyRestaurantsTableData } from '../data/company-restaurants-data';

@Injectable()
export class CompanyService extends CompaniesData
{
    allCompanies: CompanyData[] = [
        {
            id: 1,
            name: 'First Company',
            deliveryLocations: [
                {
                    id: 1,
                    name: 'Stołówka A'
                },
                {
                    id: 2,
                    name: 'Stołówka B'
                }
            ]
        },
        {
            id: 2,
            name: 'Second Company',
            deliveryLocations: [
                {
                    id: 3,
                    name: 'Stołówka C'
                },
                {
                    id: 4,
                    name: 'Stołówka D'
                }
            ]
        }
    ];

    getAllCompaniesData(): Observable<CompanyData[]>{
        return of(this.allCompanies);
    }

    getAllDeliveryLocationsData(): Observable<DeliveryLocation[]>{
        return of(this.allCompanies.flatMap(a => a.deliveryLocations));
    }
    
}